<div class="h-[calc(100vh-18rem)] rounded-b-lg scrollbar-hide" [class]="getIsInEmptyState() ? 'empty-state-container' : 'table-container'" >
  @if (tableIsLoading) {
    <div class="spinner-overlay">
      <mat-spinner class="spinner" diameter="80"></mat-spinner>
    </div>
  }
  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z0" (matSortChange)="onSortChange($event)"
    cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="dropColumn($event)">
    @for(column of displayedColumns; track column.columnDef) {
      <ng-container [matColumnDef]="column.columnDef">
        @if (column.sortable) {
          <th mat-header-cell *matHeaderCellDef mat-sort-header cdkDrag cdkDragLockAxis="x"
            cdkDragBoundary="mat-header-row">{{ column.header }}</th>
        } @else {
          <th mat-header-cell *matHeaderCellDef cdkDrag cdkDragLockAxis="x" cdkDragBoundary="mat-header-row">{{ column.header }}</th>
        }
        <td mat-cell *matCellDef="let element">
          <app-table-cell [cell]="column | mapCell: element" />
        </td>
      </ng-container>
    }
    <tr mat-header-row [class]="tableIsLoading ? 'pointer-events-none' : ''" *matHeaderRowDef="getDisplayedColumns(); sticky: true"></tr>
    <tr mat-row [class]="tableIsLoading ? 'blur-sm pointer-events-none' : ''" *matRowDef="let row; columns: getDisplayedColumns()" (click)="onSelectRow(row)"></tr>
  </table>
  @if(getIsInEmptyState()) {
    <div class="empty-state-content text-lg text-center pb-3 font-bold" [class]="tableIsLoading ? 'hidden': ''" i18n>
      No data found. Please adjust your filters.
    </div>
  }
</div>
<lib-paginator [totalItems]="totalItems" [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="pageSizes"
  (pageChange)="onPageChange($event)" />